import { cn } from '@/lib/utils/cn';
import { InAppNotification } from '@/modules/notifications/types';
import { formatDateTime } from '@/modules/notifications/utils/notifications.utils';

type NotificationItemProps = {
  notification: InAppNotification;
  onClick: (notification: InAppNotification) => void;
};

export const NotificationItem = ({ notification, onClick }: NotificationItemProps) => (
  <button
    type="button"
    onClick={() => onClick(notification)}
    className={cn(
      'w-full border-b px-3 py-3 text-left hover:bg-slate-50',
      !notification.read && 'bg-red-50/30',
    )}
  >
    <div className="mb-1 flex items-start justify-between gap-2">
      <p className="text-sm font-medium text-slate-800">{notification.title}</p>
      {!notification.read && <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-red-600" />}
    </div>
    <p className="line-clamp-2 text-xs text-slate-600">{notification.message}</p>
    <p className="mt-1 text-[11px] text-slate-400">{formatDateTime(notification.createdAt)}</p>
  </button>
);
